import Axios from "axios";

export const getAllBannerDetailsData = (page = 1, obj) => {
  let url = `${process.env.REACT_APP_NOT_SECRET_CODE}/banner-notices?page=${page}`;
  return Axios.get(url, {
    headers: {
      "Content-Type": "application/json ",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  }).then((res) => {
    return res.data;
  });
};
export const deleteDataRow = (id, obj) => {
  let url = `${process.env.REACT_APP_NOT_SECRET_CODE}/banner-notices/${id}`;

  return Axios.delete(url, {
    headers: {
      "Content-Type": "application/json ",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  }).then((res) => {
    return res.data;
  });
};

export const CreateBannerNoticeData = (Body, obj) => {
  const url = `${process.env.REACT_APP_NOT_SECRET_CODE}/banner-notices`;
  return Axios.post(
    url,
    Body,

    {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => {
      return res;
    })
    .catch((err) => err);
};
export const getBannerDetailsId = (obj, id) => {
  return Axios.get(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/banner-notices/${id}`,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error fetching packages:", err.response || err);
      throw err;
    });
};
export const updateBannerNotice = async (id, obj, data) => {
  try {
    const res = await Axios.put(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/banner-notices/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      }
    );
    return res;
  } catch (err) {
    console.error("Update Banner Notice failed", err);
    throw err;
  }
};
